import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Table,
  Spinner,
  Alert,
  Button,
  Modal,
  InputGroup, 
  Form, 
} from 'react-bootstrap';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Pagination from 'react-bootstrap/Pagination';
import toast from 'react-hot-toast';
import AddAmount from '../AddAmount';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

 
const PendingAccount = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [filteredRestaurants, setFilteredRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userid, apiGlobal, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 
  const [showAddAmountModal, setShowAddAmountModal] = useState(false);
  const [balance, setBalance] = useState('');
  const [resid, setResId] = useState('');
  const [searchRestaurantName, setSearchRestaurantName] = useState('');
  const [searchPaymentDate, setSearchPaymentDate] = useState('');
  const [refresh, setRefresh] = useState(false);
  const { permissionsAccess } = useContext(PermissionContext);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  
 
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('country_id', countryid);
      const response = await axios.post(
        `${apiGlobal}restaurant_account_list.php`,
        formData,
      );
      if (response?.data?.status && response?.data?.message === 'Success') {
        setRestaurants(response.data.data);
        setFilteredRestaurants(response.data.data);
      } else {
        setError(response.data?.message || 'Unexpected error');
      }
    } catch (err) {
      setError('Failed to fetch restaurant account data');
    } finally {
      setLoading(false);
    }
  };
 
  // Fetch data on mount and when refresh state changes
  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.adminAccountRefresh]);

  // Apply filters whenever search inputs change
  useEffect(() => {
    if (restaurants.length > 0) {
      const filtered = restaurants.filter((restaurant) => {
        const nameMatch = restaurant.restaurant_name.toLowerCase().includes(searchRestaurantName.toLowerCase());
        return nameMatch;
      });
      setFilteredRestaurants(filtered);
      // Reset to first page when filters change
      setCurrentPage(1);
    }
  }, [searchRestaurantName, restaurants]);

  const formatDateIST = (date) => {
    if (!date) return '';
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate())
      .padStart(2, '0')}`;
  };

  const handleAccountSubmit = async (value) => {
    // toast.error(value.recAmount);

    // if (value.balance === 'balance') {
    //   console.log('balance is not correct');
    //   return;
    // }
    
    if (!resid) {
      console.log('Restaurant id Missing');
      return;
    }

    const formData = new FormData();
    formData.append('user_id', userid);
    formData.append('restaurant_id', resid);
    formData.append('amount', value.recAmount);
     
    if (['1', '3', '5'].includes(value.selectPaymentType.value)) {
      formData.append('narration', value.narration || '');
    }
      
    formData.append('payment_type', value.selectPaymentType.value);
      
    if (['1', '3', '5'].includes(value.selectPaymentType.value)) {
      formData.append('payment_date', value.receivedDate);
    }
       
    if (value.selectPaymentType.value === '3') {
      if (!value.ref) {
        toast.error('Please enter Ref No');
        return;
      }
      if (!value.bankName) {
        toast.error('Please enter Bank Name');
        return;
      }
      formData.append('ref_no', value.ref);
      formData.append('bank', value.bankName);
    } else if (value.selectPaymentType.value === '5') {
      if (!value.ref) {
        toast.error('Please enter Cheque Ref No');
        return;
      }
      if (!value.bankName) {
        toast.error('Please enter Bank Name');
        return;
      }
      formData.append('ref_no', value.ref);
      formData.append('bank', value.bankName);
      formData.append('ref_date', value.chequeDate);
    }

    try {
      const url = await fetch(`${apiGlobal}/payment_receipt.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Success') {
        toast.success('Payment Done....');
        fetchData();
        setShowAddAmountModal(false);
      } else {
        console.error('Something went Wrong while doing payment...');
      }
    } catch (e) {
      console.error(e);
    }
  };
 
  const handleaccount = (id, resBalance) => {
    if (!id) {
      toast.error('restaurant id not found');
      return;
    }
    setShowAddAmountModal(true);
    setResId(id);
    setBalance(resBalance);
  };
 
  const clearFilters = () => {
    setSearchRestaurantName('');
    setSearchPaymentDate('');
  };
 
  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRestaurants = filteredRestaurants.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredRestaurants.length / itemsPerPage);

  // Spinner while loading
  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="grow" variant="primary" />
      </div>
    );
  }
 
  // Error display
  if (error) {
    return (
      <Alert variant="danger" className="text-center mt-4">
        {error}
      </Alert>
    );
  }
 
  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
        marginLeft: '15px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Restaurant Account</Typography>
        <Typography sx={{ color: 'text.primary' }}>Account</Typography>
      </Breadcrumbs>
      

      <div className="container">
        <div
          className="mb-4"
          style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
        >
          <h5
            className="mb-0"
            style={{
            color: '#495057',
            marginRight: '20px',
            fontWeight: '600',
          }}
          >
            Filter Payment
          </h5>
          <div 
            style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px', 
            flexWrap: 'wrap', 
          }}
          >
            <InputGroup style={{ maxWidth: '200px' }}>
              <Form.Control
                type="text"
                placeholder="Search by Restaurant Name"
                value={searchRestaurantName}
                onChange={e => setSearchRestaurantName(e.target.value)}
                style={{
                borderRadius: '25px',
                padding: '8px',
                border: '1px solid #ddd',
              }}
              />
            </InputGroup>

            <Button
              variant="outline-danger"
              style={{
              borderRadius: '25px',
              padding: '8px 16px',
            }}
              onClick={clearFilters}
            >
              Clear Filters
            </Button>

            <Button
              variant="outline-danger"
              style={{
              borderRadius: '25px',
              padding: '8px 16px',
            }}
              onClick={() => setRefresh(prev => !prev)}
            >
              Refresh
            </Button>
          </div>
        </div>

        {filteredRestaurants.length === 0 ? (
          <div className="text-center">No restaurant accounts found.</div>
        ) : (
          <Table
            responsive
            style={{
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>Sr.no</th>
                <th>Restaurant Name</th>
                <th>Gross Amount (₹)</th>
                <th>Paid Amount (₹)</th>
                <th>Balance (₹)</th>
                {permissionsAccess?.[7]?.master_id === '8'
          && permissionsAccess?.[7]?.create === 1 && (
          <th className="text-center">➕</th>
                )}
              </tr>
            </thead>
            <tbody>
              {currentRestaurants.map((restaurant, index) => (
                <tr key={restaurant.id} style={{ textAlign: 'center', padding: '20px' }}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{restaurant?.restaurant_name}</td>
                  <td>₹{parseFloat(restaurant?.gross_amount || 0).toLocaleString()}</td>
                  <td>₹{parseFloat(restaurant?.paid_amount || 0).toLocaleString()}</td>
                  <td>₹{parseFloat(restaurant?.balance || 0).toLocaleString()} {restaurant?.balance_label}</td>
                  {permissionsAccess?.[7]?.master_id === '8'
          && permissionsAccess?.[7]?.create === 1 && (
          <td className="text-center">
            <Button
              variant="success"
              size="sm"
              onClick={() => handleaccount(restaurant?.restaurant_id, restaurant?.balance)}
            >
              Add
            </Button>
          </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <div
          style={{
            bottom: '20px',
            right: '20px',
            zIndex: 999,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {filteredRestaurants.length > 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
              ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
            />
          </Pagination>
          )}
        </div>
      
      </div>
      {/* Modal to add amount */}
      <Modal
        show={showAddAmountModal}
        onHide={() => setShowAddAmountModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddAmount
            handleAccountSubmit={handleAccountSubmit}
            balance={balance}
            setShowAddAmountModal={setShowAddAmountModal}
          />
        </Modal.Body>
      </Modal>
    </div>  
  );
};
 
export default PendingAccount;
